// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateFrame_date__frame__7HaUA {
	position: relative;
	width: 69.375rem;
	height: 5.625rem;
	border-radius: 0.5rem;
	background: rgba(254, 247, 229, 0.5);

	padding: 1.25rem 2.81rem;

	display: flex;
	gap: 1.5rem;
}

.DateFrame_input__date__DUsnJ {
	position: relative;
	width: 15rem;
	height: 3.125rem;

	border-radius: 0.4375rem;
	border: 1px solid var(--accent-color, #956446);
	background: white;

	box-shadow: -2px 4px 5px -4px rgba(109, 95, 85, 0.08);
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;

	padding: 0.31rem 1.25rem;
}

.DateFrame_search__btn__3FvZ\\+ {
	width: 15rem;
	height: 3.125rem;
	border-radius: 0.4375rem;
	border: 1px solid var(--accent-color, #956446);
	background-color: var(--accent-color);

	/* btn */
	box-shadow: -2px 4px 5px 0px rgba(148, 93, 60, 0.06);

	color: var(--text-color, #fff);
	text-align: center;
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 600;
	line-height: 160%; /* 1.6rem */
	cursor: pointer;

	display: flex;
	align-items: center;
	justify-content: center;
}

.DateFrame_input__text_side__r7pDh {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 0.2rem;
}

.DateFrame_input__title__qvCFf {
	color: var(--pink-color, #d7bbbb);
	text-align: center;

	/* text super small */
	font-family: 'Noto Sans';
	font-size: 0.75rem;
	font-style: normal;
	font-weight: 500;
	line-height: 100%; /* 1.2rem */
}

.DateFrame_input__text__7GyUh {
	color: var(--accent-color, #956446);
	text-align: center;

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 100%; /* 1.6rem */
}

.DateFrame_click__side__qhbhM {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.DateFrame_persons__modal__j9Nsa {
	cursor: default;
	position: absolute;
	top: -6rem;
	left: 0;
	width: 15rem;

	border-radius: 0.5rem;
	background: var(--text-color, #fff);

	padding: 0.94rem 1.25rem;
	display: flex;
	flex-direction: column;
	gap: 0.31rem;
	justify-content: space-between;

	/* btn secondary */
	box-shadow: -2px 4px 5px -4px rgba(109, 95, 85, 0.08);
}

.DateFrame_modal__item__e1XCv {
	width: 100%;
	display: flex;

	justify-content: space-between;
}

.DateFrame_item__input__side__XSVst {
	display: flex;
	align-items: center;
	gap: 0.94rem;
}

.DateFrame_item__input__side__XSVst svg {
	cursor: pointer;
	width: 1.25rem;
	height: 1.25rem;
}

.DateFrame_item__title__dWTv0 {
	color: var(--accent-color, #875b52);
	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

.DateFrame_item__count__026CR {
	color: var(--accent-color, #875b52);
	/* text small bold */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 700;
	line-height: 160%; /* 1.6rem */
}

.DateFrame_without__bg__rtD2k {
	background: none;
}

@media (max-width: 460px) {
	.DateFrame_date__frame__7HaUA {
		flex-direction: column;
		width: 100%;
		height: auto;
		align-items: center;
		padding: 1.25rem;
		gap: 0.63rem;
		background: none;
	}
	.DateFrame_input__date__DUsnJ {
		width: 100%;
	}
	.DateFrame_search__btn__3FvZ\\+ {
		width: 100%;
	}
	.DateFrame_persons__modal__j9Nsa {
		width: 100%;
		border-top: 1px solid var(--accent-color);
		gap: 1rem;
		top: -6.5rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/DateFrame/DateFrame.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,qBAAqB;CACrB,oCAAoC;;CAEpC,wBAAwB;;CAExB,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;;CAEhB,wBAAwB;CACxB,8CAA8C;CAC9C,iBAAiB;;CAEjB,qDAAqD;CACrD,eAAe;CACf,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;;CAEnB,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,wBAAwB;CACxB,8CAA8C;CAC9C,qCAAqC;;CAErC,QAAQ;CACR,oDAAoD;;CAEpD,8BAA8B;CAC9B,kBAAkB;CAClB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;CAC9B,eAAe;;CAEf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,uBAAuB;CACvB,WAAW;AACZ;;AAEA;CACC,iCAAiC;CACjC,kBAAkB;;CAElB,qBAAqB;CACrB,wBAAwB;CACxB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;;CAElB,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,UAAU;CACV,OAAO;CACP,YAAY;;CAEZ,qBAAqB;CACrB,mCAAmC;;CAEnC,wBAAwB;CACxB,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,8BAA8B;;CAE9B,kBAAkB;CAClB,qDAAqD;AACtD;;AAEA;CACC,WAAW;CACX,aAAa;;CAEb,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,mCAAmC;CACnC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,mCAAmC;CACnC,oBAAoB;CACpB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;CACA;EACC,WAAW;CACZ;CACA;EACC,WAAW;CACZ;CACA;EACC,WAAW;EACX,yCAAyC;EACzC,SAAS;EACT,YAAY;CACb;AACD","sourcesContent":[".date__frame {\n\tposition: relative;\n\twidth: 69.375rem;\n\theight: 5.625rem;\n\tborder-radius: 0.5rem;\n\tbackground: rgba(254, 247, 229, 0.5);\n\n\tpadding: 1.25rem 2.81rem;\n\n\tdisplay: flex;\n\tgap: 1.5rem;\n}\n\n.input__date {\n\tposition: relative;\n\twidth: 15rem;\n\theight: 3.125rem;\n\n\tborder-radius: 0.4375rem;\n\tborder: 1px solid var(--accent-color, #956446);\n\tbackground: white;\n\n\tbox-shadow: -2px 4px 5px -4px rgba(109, 95, 85, 0.08);\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\tpadding: 0.31rem 1.25rem;\n}\n\n.search__btn {\n\twidth: 15rem;\n\theight: 3.125rem;\n\tborder-radius: 0.4375rem;\n\tborder: 1px solid var(--accent-color, #956446);\n\tbackground-color: var(--accent-color);\n\n\t/* btn */\n\tbox-shadow: -2px 4px 5px 0px rgba(148, 93, 60, 0.06);\n\n\tcolor: var(--text-color, #fff);\n\ttext-align: center;\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 160%; /* 1.6rem */\n\tcursor: pointer;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.input__text_side {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: center;\n\tgap: 0.2rem;\n}\n\n.input__title {\n\tcolor: var(--pink-color, #d7bbbb);\n\ttext-align: center;\n\n\t/* text super small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 0.75rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 100%; /* 1.2rem */\n}\n\n.input__text {\n\tcolor: var(--accent-color, #956446);\n\ttext-align: center;\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 100%; /* 1.6rem */\n}\n\n.click__side {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n.persons__modal {\n\tcursor: default;\n\tposition: absolute;\n\ttop: -6rem;\n\tleft: 0;\n\twidth: 15rem;\n\n\tborder-radius: 0.5rem;\n\tbackground: var(--text-color, #fff);\n\n\tpadding: 0.94rem 1.25rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.31rem;\n\tjustify-content: space-between;\n\n\t/* btn secondary */\n\tbox-shadow: -2px 4px 5px -4px rgba(109, 95, 85, 0.08);\n}\n\n.modal__item {\n\twidth: 100%;\n\tdisplay: flex;\n\n\tjustify-content: space-between;\n}\n\n.item__input__side {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.94rem;\n}\n\n.item__input__side svg {\n\tcursor: pointer;\n\twidth: 1.25rem;\n\theight: 1.25rem;\n}\n\n.item__title {\n\tcolor: var(--accent-color, #875b52);\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.item__count {\n\tcolor: var(--accent-color, #875b52);\n\t/* text small bold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.without__bg {\n\tbackground: none;\n}\n\n@media (max-width: 460px) {\n\t.date__frame {\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\theight: auto;\n\t\talign-items: center;\n\t\tpadding: 1.25rem;\n\t\tgap: 0.63rem;\n\t\tbackground: none;\n\t}\n\t.input__date {\n\t\twidth: 100%;\n\t}\n\t.search__btn {\n\t\twidth: 100%;\n\t}\n\t.persons__modal {\n\t\twidth: 100%;\n\t\tborder-top: 1px solid var(--accent-color);\n\t\tgap: 1rem;\n\t\ttop: -6.5rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date__frame": `DateFrame_date__frame__7HaUA`,
	"input__date": `DateFrame_input__date__DUsnJ`,
	"search__btn": `DateFrame_search__btn__3FvZ+`,
	"input__text_side": `DateFrame_input__text_side__r7pDh`,
	"input__title": `DateFrame_input__title__qvCFf`,
	"input__text": `DateFrame_input__text__7GyUh`,
	"click__side": `DateFrame_click__side__qhbhM`,
	"persons__modal": `DateFrame_persons__modal__j9Nsa`,
	"modal__item": `DateFrame_modal__item__e1XCv`,
	"item__input__side": `DateFrame_item__input__side__XSVst`,
	"item__title": `DateFrame_item__title__dWTv0`,
	"item__count": `DateFrame_item__count__026CR`,
	"without__bg": `DateFrame_without__bg__rtD2k`
};
export default ___CSS_LOADER_EXPORT___;
